import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import ImageIcon from '@mui/icons-material/Image'
import DescriptionIcon from '@mui/icons-material/Description'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'

export type FileType = 'image' | 'pdf' | 'document' | 'csv' | 'audio' | 'other'

interface FileIconProps {
  fileType: FileType
  size?: 'small' | 'medium' | 'large'
}

export const FileIcon = ({ fileType, size = 'medium' }: FileIconProps) => {
  const iconSize = size === 'small' || size === 'large' ? size : undefined
  const sxSize = size === 'large' ? { fontSize: 40 } : undefined

  switch (fileType) {
    case 'image':
      return <ImageIcon fontSize={iconSize} sx={sxSize} />
    case 'pdf':
      return <PictureAsPdfIcon fontSize={iconSize} sx={sxSize} />
    case 'document':
    case 'csv':
      return <DescriptionIcon fontSize={iconSize} sx={sxSize} />
    default:
      return <InsertDriveFileIcon fontSize={iconSize} sx={sxSize} />
  }
}
